import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import Image from "next/image";
import "tippy.js/dist/tippy.css";
import Link from "next/link";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { axiosIns } from "../../config/axiosIns";

const fetchTruckloads = () =>
  axiosIns.get(`/truckloads/all`).then(({ data }) => data);

const MoreTruckloads = () => {
  const {
    error,
    data: Truckloads,
    isLoading,
    isError,
  } = useQuery(["getTruckloadById"], fetchTruckloads);
  return (
    <>
      {isLoading ? (
        <div className="grid h-screen place-items-center z-10">
          <div className="text-center">
            <div role="status">
              <svg
                className="inline mr-2 w-8 h-8 text-jacarta dark:text-accent animate-spin fill-white"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : isError ? (
        <span>Error: {error.message}</span>
      ) : (
        <>
          <Swiper
            modules={[Navigation, Pagination, Scrollbar]}
            breakpoints={{
              // when window width is >= 640px
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              // when window width is >= 768px
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              900: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1100: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            className=" card-slider-4-columns !py-5"
          >
            {Truckloads?.truckloads.map((item) => {
              const { _id, images, title, slug, store, isSold } = item;
              return (
                <SwiperSlide key={_id}>
                  <article>
                    <div className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2xl border bg-white p-[1.1875rem] transition-shadow hover:shadow-lg">
                      <Link href={`/truckload/${slug || _id}`}>
                        <a className="flex space-x-[0.625rem]">
                          <figure className=" relative w-[74.5%] h-full">
                            <Image
                              src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}${
                                "/" + images[0]?.url || "/no_product.png"
                              }`}
                              alt="item 1"
                              className="rounded-[0.625rem]"
                              width={150}
                              height={240}
                              objectFit="cover"
                              layout="responsive"
                            />
                            {isSold && (
                              <div className="absolute left-3 -bottom-1">
                                <img src="/images/sold.svg" alt="sold" />
                              </div>
                            )}
                            <div
                              className={
                                store?.toLowerCase() === "hd"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-orange-600 p-2"
                                  : store?.toLowerCase() === "tgt"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-red p-2"
                                  : store?.toLowerCase() === "lws"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-blue p-2"
                                  : store?.toLowerCase() === "amz"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-yellow p-2"
                                  : store?.toLowerCase() === "dg"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-yellow p-2"
                                  : store?.toLowerCase() === "kl"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-red p-2"
                                  : store?.toLowerCase() === "wm"
                                  ? "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-blue p-2"
                                  : "absolute top-3 left-3 font-display flex items-center space-x-1 rounded-md bg-red p-2"
                              }
                            >
                              <span
                                className={
                                  store?.toLowerCase() === "wm"
                                    ? "text-yellow text-sm"
                                    : store?.toLowerCase() === "amz" ||
                                      store?.toLowerCase() === "dg"
                                    ? "text-black text-sm"
                                    : "text-white text-sm"
                                }
                              >
                                {store}
                              </span>
                            </div>
                          </figure>
                          <span className="flex w-1/3 flex-col space-y-[0.625rem]">
                            {item.truckloadItems &&
                              item.truckloadItems
                                .slice(0, 3)
                                .map((prod, index) =>
                                  prod.images.length > 0 ? (
                                    <img
                                      key={"images-" + index}
                                      src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/${prod.images[0].url}`}
                                      alt="item 1"
                                      className="h-full rounded-[0.625rem] object-cover"
                                      loading="lazy"
                                    />
                                  ) : (
                                    <img
                                      key={"images-" + index}
                                      src={"/images/no_product.png"}
                                      alt="item 1"
                                      className="h-full rounded-[0.625rem] object-cover"
                                      loading="lazy"
                                    />
                                  )
                                )}
                          </span>
                        </a>
                      </Link>

                      <Link href={`/truckload/${slug || _id}`}>
                        <a className="font-display hover:text-accent dark:hover:text-accent text-jacarta-700 mt-4 block text-base dark:text-white">
                          {title}
                        </a>
                      </Link>

                      <div className="mt-2 flex items-center justify-between text-sm font-medium tracking-tight">
                        <div className="flex flex-wrap items-center">
                          <Link href={`/truckload/item_${slug || _id}`}>
                            <a className="mr-2 shrink-0">
                              <img
                                src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_URL}/${item.merchantProfile?.thumbnail}`}
                                alt="owner"
                                className="h-5 w-5 rounded-full"
                              />
                            </a>
                          </Link>
                          <span className="dark:text-jacarta-400 mr-1">by</span>
                          <Link href={`/truckload/${slug || _id}`}>
                            <a className="text-accent">
                              <span>{item.merchantProfile?.name}</span>
                            </a>
                          </Link>
                        </div>
                        {/* <span className="dark:text-jacarta-300 text-sm">
                      {itemsCount} Items
                    </span> */}
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              );
            })}
          </Swiper>
          {/* <!-- Slider Navigation --> */}
          <div className="group bids-swiper-button-prev swiper-button-prev shadow-white-volume absolute !top-1/2 !-left-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-base sm:!-left-6 after:hidden">
            <MdKeyboardArrowLeft />
          </div>
          <div className="group bids-swiper-button-next swiper-button-next shadow-white-volume absolute !top-1/2 !-right-4 z-10 -mt-6 flex !h-12 !w-12 cursor-pointer items-center justify-center rounded-full bg-white p-3 text-base sm:!-right-6 after:hidden">
            <MdKeyboardArrowRight />
          </div>
        </>
      )}
    </>
  );
};

export default MoreTruckloads;
